import { createSignal } from '@verclam/pulsar';

/**
 * Carries the usage value alone (`interview_transcription`, …), a primitive — never a `ModelAssignmentView`.
 * Read by all three affectation screens through the single `UsageSettingsSidebar` mounted by
 * `UsageAssignmentsBoard`, itself shared by the three.
 */
const usageSettingsSidebarSignal = createSignal<string | null>(null);

export const openUsageSettingsSidebar = (usage: string): void => {
	usageSettingsSidebarSignal.value = usage;
};

export const closeUsageSettingsSidebar = (): void => {
	usageSettingsSidebarSignal.value = null;
};

export default usageSettingsSidebarSignal;
